'use client'

import { Cell, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import SellerProtectionImage from './SellerProtectionImage'
import SellerProcetectionPolicies from './SellerProtectionPolicies'

type Props = {
  transactionId: string | null | undefined
  transactionStatus: number | null | undefined
  shipmentStatus: number | null | undefined
}

const SellerProtectionInformation = ({
  transactionId,
  transactionStatus,
  shipmentStatus,
}: Props) => {
  const translate = useTranslate('seller_protection_dialog')

  return (
    <div className="u-text-center">
      <SellerProtectionImage />
      <Cell body={<Text as="h1" type="heading" text={translate('title')} />} />
      <SellerProcetectionPolicies
        transactionId={transactionId}
        transactionStatus={transactionStatus}
        shipmentStatus={shipmentStatus}
      />
    </div>
  )
}

export default SellerProtectionInformation
